import { PureComponent } from 'react'
import { sharedState } from '../../utils/configure-service';

export class BaseComponent extends PureComponent {
    constructor(props) {
        super(props);

        this._service = null;
        this._sharedState = sharedState.user();
        this._subscribers = []

        console.log('[BaseComponent] ' + this.constructor.name + ' constructor. Props:', this.props);
    }

    get sharedState() {
        return this._sharedState
    }

    subscribeToSharedState(subscribers, cb) {
        var subscriber = this._sharedState.subscribe(subscribers, cb);
        this._subscribers.push(subscriber);
    }

    unsubscribeFromSharedState() {
        for(var x of this._subscribers) {
            x.close();
        }
        this._subscribers = [];
    }

    componentWillUnmount() {
        this.unsubscribeFromSharedState()
    }
}

